import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { setAppointmentDetails } from 'slices/appointmentDetailSlice';
import { acceptAppointmentDetails, rejectAppointmentDetails, fetchAppointmentDetails, appointmentDetailsSelector } from 'slices/appointmentDetailSlice';
import Swal from 'sweetalert2';
import InterviewInviteTable from './InterviewInviteTable';
import ViewTable from './appointment/view/ViewTable';
import moment from 'moment';

const AppointmentDetails = () => {
    const { appointmentDetails, loader } = useSelector(appointmentDetailsSelector);
    const [statusMessage, setStatusMessage] = useState();
    const [status, setStatus] = useState();
    const [isChecked, setIsChecked] = useState(false);
    const dispatch = useDispatch();
    const params = new URLSearchParams(window.location.search);
    const [token, setToken] = useState(params?.get("token"));


    const handleCheckbox = () => {
        setIsChecked(!isChecked);
    };
    useEffect(() => {
        dispatch(fetchAppointmentDetails(token, submitCallback));
        return () => {
            dispatch(setAppointmentDetails({}));
        };
    }, [token]);

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            });
            setStatusMessage(message);
        } else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
            setStatusMessage(message);
            setStatus(status);
        }
    };

    function AcceptInvite() {
        dispatch(acceptAppointmentDetails(token, submitCallback));
        setStatus(status);
        Swal.fire({
            title: "Appointment Accepted!",
            text: statusMessage,
            icon: "success",
        });
        dispatch(fetchAppointmentDetails(token, submitCallback));
        // setTimeout(() => {
        //     window.location.reload();
        // }, 2000);
    }

    function RejectInvite() {
        dispatch(rejectAppointmentDetails(token, submitCallback));
        Swal.fire({
            title: "Appointment Rejected!",
            text: statusMessage,
            icon: "error",
        });
        setTimeout(() => {
            window.location.reload();
        }, 2000);
    }

    if (loader) {
        return (
            <div className="loader_wrapper">
                <Spinner size="xl">
                    Loading...
                </Spinner>
            </div>
        );
    }

    const rawDatetime = appointmentDetails?.date + " " + appointmentDetails?.start_time;

    const formattedDate = moment(rawDatetime, 'YYYY-MM-DD HH:mm:ss').format('MMM D, YYYY HH:mm:ss');
    return (
        <>
            {statusMessage === 'Data retrieved successfully.' && appointmentDetails ? (
            <div className='main-freePage'>
                <img src="/images/logo.png" alt="" />
                <div className='table_wrapper'>
                    <div className="row_main_head bg-primary-secondaryCard">
                        <h2 className={`main_heading main_heading1`}>View Appointment # {appointmentDetails?.appid}</h2>
                        {appointmentDetails?.status && <span className="main_heading main_heading1">Status: {appointmentDetails?.status}</span>}

                    </div>
                    <div className="row_main_head bg-light-secondaryCard mt-3">
                        <h2 className={`main_heading2`} toLowerCase={'text-lowercase'}>Date & Time <span className="dateTime">{formattedDate}</span></h2>
                        <div className='mb-3'>
                            <div className='text-transform-capitalize main_heading2' >
                                <span className="appLanguage">{appointmentDetails?.language?.name}</span>
                            </div>
                        </div>
                    </div>
                    <div className='px-2'>

                        <ViewTable item={appointmentDetails} />
                    </div>

                </div>
            </div>

            ) : statusMessage === 'Page Expired' ? (
                <div className="error-page-container">
                    <img src="/images/logo.png" alt="" />
                    <h4>OOps! {statusMessage}</h4>
                    <Link to="/" className="main_button mt-5">
                        Go to home page
                    </Link>
                </div>
            ) : (
                <div className="error-page-container">
                    <img src="/images/logo.png" alt="" />
                    <h4>Oopps! The page you were looking for doesn't exist.</h4>
                    <p>
                        <Link to="/" className="button">
                            Go to home page
                        </Link>
                    </p>
                </div>
            )}
        </>
    );
};

export default AppointmentDetails;
